import Api from 'libs/api/index';

class CompanyDocumentCategories extends Api {
  constructor() {
    super('admin/company_document_categories/');
  }
}

export default CompanyDocumentCategories;
